/* Emoto Vlašim — motiv v3: „Moje motorka“, přidání do košíku z karty, spodní lišta na mobilu.
   Košík: stejná událost jako Horizon (CartLinesUpdateEvent) → šuplík košíku i počet v hlavičce
   se obnoví samy (cart-drawer.js, cart-icon.js). */
import { CartLinesUpdateEvent } from '@shopify/events';

const KLIC = 'emoto_motorka';
const NAZVY = { ex: 'Varg EX', 'mx-1-2': 'Varg MX 1.2', 'mx-1-0': 'Varg MX (1.0)', sm: 'Varg SM' };

const moje = () => {
  try { return localStorage.getItem(KLIC) || ''; } catch (e) { return ''; }
};
const uloz = (m) => {
  try { m ? localStorage.setItem(KLIC, m) : localStorage.removeItem(KLIC); } catch (e) { /* soukromé okno */ }
};

function oznac(root = document) {
  const m = moje();
  root.querySelectorAll('[data-emoto-model]').forEach((el) => {
    el.classList.toggle('is-moje', !!m && el.getAttribute('data-emoto-model') === m);
  });
  root.querySelectorAll('.e-fit[data-model]').forEach((s) => {
    s.classList.toggle('is-hit', !!m && s.getAttribute('data-model') === m);
  });
  root.querySelectorAll('[data-emoto-sedina]').forEach((el) => {
    const modely = (el.getAttribute('data-modely') || '').split(' ').filter(Boolean);
    const msg = el.querySelector('.e-sedina__msg');
    if (!msg) return;
    if (!m || !modely.length) { msg.hidden = true; return; }
    const ok = modely.includes(m);
    msg.textContent = ok ? `✓ Sedí na váš ${NAZVY[m]}` : `Na váš ${NAZVY[m]} podle katalogu výrobce nesedí`;   // 27. 9.: web vyká
    msg.className = `e-sedina__msg ${ok ? 'is-ok' : 'is-no'}`;
    msg.hidden = false;
  });
}

// volba motorky: dlaždice modelů, box „Najdi díly“, čipy v kategorii (data-emoto-volba="ex" | "")
document.addEventListener('click', (e) => {
  const volba = e.target.closest('[data-emoto-volba]');
  if (volba) uloz(volba.getAttribute('data-emoto-volba'));
});

// Do košíku z karty (jen karty s jedinou variantou; víc variant = odkaz na detail)
async function pridat(btn) {
  const variantId = btn.getAttribute('data-variant');
  if (!variantId || btn.disabled) return;
  btn.disabled = true;
  const puvodni = btn.innerHTML;
  const sekce = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  const odlozeny = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: odlozeny.promise,
    })
  );
  try {
    const odpoved = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sekce.join(',') }),
    }).then((r) => r.json());
    const kosik = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json());
    const chyba = Boolean(odpoved.status);
    odlozeny.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(kosik),
      detail: {
        items: kosik.items,
        source: 'product-form-component',
        sourceId: `emoto-karta-${variantId}`,
        itemCount: 1,
        productId: btn.getAttribute('data-product'),
        sections: odpoved.sections,
        didError: chyba,
      },
    });
    btn.classList.toggle('is-ok', !chyba);
    btn.innerHTML = chyba ? (odpoved.message || 'Nelze přidat') : '✓ V košíku';
  } catch (err) {
    odlozeny.reject(err);
    btn.innerHTML = 'Zkuste to znovu';
  }
  setTimeout(() => {
    btn.innerHTML = puvodni;
    btn.classList.remove('is-ok');
    btn.disabled = false;
  }, 2200);
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-emoto-koupit]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  pridat(btn);
});

// Spodní lišta: „Hledat“ otevře vyhledávání Horizonu
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-emoto-hledat]');
  if (!b) return;
  const tlacitko = document.querySelector('.search-action button, search-button button');
  if (tlacitko) {
    e.preventDefault();
    tlacitko.click();
  }
});

// Stránka motorky (/collections/dily-varg-mx-1-2) nebo kategorie s filtrem modelu = tahle motorka je „moje“,
// ať se na ni přišlo odkudkoli (dlaždice na úvodce, odkaz z Poradny, Google). Jinak zůstala v paměti prohlížeče
// dřívější volba a karta dílu hlásila „Na tvůj Varg EX nesedí“, i když zákazník procházel díly MX (Vít 26. 9.).
const stranka = document.querySelector('[data-emoto-aktivni]');
if (stranka && stranka.getAttribute('data-emoto-aktivni')) uloz(stranka.getAttribute('data-emoto-aktivni'));
oznac();
// Horizon překresluje části stránky (filtry, stránkování) — po změně znovu označit
new MutationObserver((zaznamy) => {
  if (zaznamy.some((z) => [...z.addedNodes].some((n) => n.nodeType === 1 && n.querySelector?.('.e-fit, [data-emoto-sedina], [data-emoto-model]')))) {
    oznac();
  }
}).observe(document.body, { childList: true, subtree: true });
